import DatePickerContainer from "../../../../Components/Forms/FormsWidgets/DatePicker/DatePicker"

const DatePicker = () => {
  return (
    <div className='page-body'>
      <DatePickerContainer />
    </div>
  )
}

export default DatePicker